'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactQrSvg = require('react-qr-svg');

var _reactRedux = require('react-redux');

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _Home = require('../Home/');

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _image_voucher = require('../../AccountManagement/image_voucher.jpg');

var _image_voucher2 = _interopRequireDefault(_image_voucher);

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _lib = require('helpers/lib');

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BookingReward = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    COUPON_CODE_DETAIL: state.voucher.COUPON_CODE_DETAIL,
    user: state.auth.user
  };
}, {
  getCodeDetail: voucherActions.getCodeDetail,
  resetBooking: bookingActions.resetBooking,
  setDefaultBooking: bookingActions.setDefaultBooking,
  changeShopBeforeBooking: bookingActions.changeShopBeforeBooking,
  showDownloadAppPopup: setupActions.showDownloadAppPopup,
  setPathName: _setup.setPathName
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(BookingReward, _Component);

  function BookingReward() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, BookingReward);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = BookingReward.__proto__ || (0, _getPrototypeOf2.default)(BookingReward)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isUsed: false,
      showModalJoin: false,
      warningJoin: {
        title: 'Thông Báo',
        code: 'warning',
        content: 'Bạn có chắc chắn sử dụng ưu đãi này không?',
        note: ''
      },
      infoMessage: {
        title: '',
        content: ''
      },
      showModalInfo: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(BookingReward, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var params = this.props.params;

      this.props.getCodeDetail(params.code);
      // this.props.getVoucherById(params.handle);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.params.code !== nextProps.params.code) {
        this.props.getCodeDetail(nextProps.params.code);
      }
    }
  }, {
    key: 'toBooking',
    value: function toBooking() {
      this.props.showDownloadAppPopup();
      // const {
      //   COUPON_CODE_DETAIL: {
      //     data: {
      //       code,
      //       packageService: { shop, service },
      //     },
      //   },
      //   setDefaultBooking,
      //   resetBooking,
      //   history,
      //   changeShopBeforeBooking,
      //   user,
      // } = this.props;
      // resetBooking();
      // changeShopBeforeBooking(shop, user);
      // const bookingServices = [
      //   { service: service._id, number: 1, name: service.name },
      // ];
      // const submit = {
      //   bookingServices,
      //   code,
      //   shop,
      //   coupon: this.props.COUPON_CODE_DETAIL.data,
      // };
      // setDefaultBooking(submit);
      // history.push(`/dat-lich`);
      // if (this.props.user) {
      //   ReactGA.event({
      //     category: 'Promotion',
      //     action: 'Clicked Booking button',
      //     label: `${code}`,
      //   });
      //   ReactGA.event({
      //     category: 'Booking',
      //     action: 'Clicked To Step 1 (General Voucher)',
      //     label: `${shop.name}`,
      //   });
      // } else {
      //   ReactGA.event({
      //     category: 'Promotion',
      //     action: 'Clicked Booking button (not logged in)',
      //     label: `${code}`,
      //   });
      // }
    }
  }, {
    key: 'moreDetail',
    value: function moreDetail(shopName) {
      _reactGa2.default.event({
        category: 'Shop',
        action: 'Clicked Shop Card from voucher',
        label: '' + shopName
      });
    }
  }, {
    key: 'onBookingCallButtonClick',
    value: function onBookingCallButtonClick() {
      var campaign = this.props.COUPON_CODE_DETAIL.data.campaign;

      _reactGa2.default.event({
        category: 'Promotion',
        action: 'Clicked Booking Call button',
        label: '' + campaign.code
      });
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      var styles = require('./Voucher.scss');
      var shop = this.props.COUPON_CODE_DETAIL.data.packageService.shop;

      if (shop.isBooking) {
        return _react2.default.createElement(
          'div',
          {
            className: styles.btn + ' ' + styles.btnJoin + ' ' + styles.available,
            onClick: this.toBooking.bind(this)
          },
          '\u0110\u1EB7t L\u1ECBch'
        );
      }
      return _react2.default.createElement(
        'a',
        {
          className: styles.btn + ' ' + styles.btnJoin,
          href: 'tel:' + (0, _lib.getPhone)(shop.phone),
          onClick: this.onBookingCallButtonClick.bind(this)
        },
        _react2.default.createElement(
          'span',
          null,
          'G\u1ECDi \u0110\u1EB7t L\u1ECBch'
        )
      );
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _this2 = this;

      var styles = require('./Voucher.scss');
      var data = this.props.COUPON_CODE_DETAIL.data;
      var campaign = data.campaign,
          code = data.code,
          _data$packageService = data.packageService,
          service = _data$packageService.service,
          shop = _data$packageService.shop,
          image = _data$packageService.image,
          displayValue = _data$packageService.displayValue;

      return _react2.default.createElement(
        'div',
        {
          id: 'voucherDetail',
          className: styles.voucherDetail,
          ref: 'voucherDetail'
        },
        _react2.default.createElement(
          'div',
          { className: styles.modalBody },
          _react2.default.createElement(
            'div',
            { className: styles.image },
            _react2.default.createElement('i', {
              className: 'fa fa-angle-left',
              onClick: this.props.history.goBack
            }),
            _react2.default.createElement('img', { src: image || _image_voucher2.default, alt: 'H\xECnh avatar' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.primaryInfo },
            _react2.default.createElement(
              'div',
              { className: styles.info },
              _react2.default.createElement(
                'div',
                { className: styles.title },
                campaign.name
              ),
              _react2.default.createElement(
                'div',
                { className: styles.shop },
                _react2.default.createElement('img', { src: '/icon/svg/shop.svg', alt: '' }),
                shop.name,
                ' -',
                ' ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    to: '/' + shop.handle,
                    onClick: function onClick() {
                      return _this2.moreDetail(shop.name);
                    }
                  },
                  'Th\xF4ng tin shop'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.address },
                _react2.default.createElement('img', { src: '/icon/svg/map.svg', alt: '' }),
                shop.address
              ),
              _react2.default.createElement(
                'div',
                { className: styles.service },
                _react2.default.createElement('img', { src: '/icon/svg/flower.svg', alt: '' }),
                service.name
              ),
              _react2.default.createElement(
                'div',
                { className: styles.times },
                _react2.default.createElement('img', { src: '/icon/svg/calendar.svg', alt: '' }),
                'T\u1EEB ' + (0, _moment2.default)(new Date(campaign.startDate)).format('DD/MM/YYYY') + ' \u0111\u1EBFn ' + (0, _moment2.default)(new Date(campaign.endDate)).format('DD/MM/YYYY')
              ),
              _react2.default.createElement(
                'div',
                { className: styles.price },
                _react2.default.createElement('img', { src: '/icon/svg/gift.svg', alt: '' }),
                _react2.default.createElement(
                  'span',
                  { className: styles.newPrice },
                  (0, _numeral2.default)(displayValue).format('0,0') + ' đ'
                ),
                _react2.default.createElement(
                  'span',
                  { className: styles.oldPrice },
                  (0, _numeral2.default)(service.price).format('0,0') + ' đ'
                )
              )
            ),
            code && !shop.isBooking && _react2.default.createElement(
              'div',
              { className: styles.serviceCode },
              _react2.default.createElement(
                'h2',
                { className: styles.lmTitle, style: { marginBottom: 0 } },
                'M\xE3 s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.code },
                code
              ),
              _react2.default.createElement(
                'div',
                { className: styles.qrCodeContainer },
                _react2.default.createElement(_reactQrSvg.QRCode, { value: code, style: { width: 128 } })
              ),
              _react2.default.createElement(
                'span',
                { className: styles.serviceCodeHint },
                '* Vui l\xF2ng \u0111\u01B0a m\xE3 QR ho\u1EB7c copy m\xE3 ph\xEDa tr\xEAn cho nh\xE2n vi\xEAn \u0111\u1EC3 s\u1EED d\u1EE5ng d\u1ECBch v\u1EE5, ho\u1EB7c g\u1ECDi \u0111\u1EB7t l\u1ECBch b\xEAn d\u01B0\u1EDBi \u0111\xE2y.'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.description },
              _react2.default.createElement(
                'h2',
                { className: styles.lmTitle },
                ' M\xF4 t\u1EA3 d\u1ECBch v\u1EE5:'
              ),
              _react2.default.createElement('div', {
                className: styles.content,
                dangerouslySetInnerHTML: { __html: service.description }
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.condition },
              _react2.default.createElement(
                'h2',
                { className: styles.lmTitle },
                '\u0110i\u1EC1u ki\u1EC7n s\u1EED d\u1EE5ng'
              ),
              _react2.default.createElement('div', {
                className: styles.content,
                dangerouslySetInnerHTML: { __html: campaign.condition }
              })
            ),
            _react2.default.createElement(_Home.Promotion, {
              history: this.props.history,
              title: 'Ưu đãi khác',
              promotionHandle: data && data.packageService && data.packageService.handle
            }),
            _react2.default.createElement(
              'div',
              { className: styles.btnGroup },
              this.renderButton()
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./Voucher.scss');
      var data = this.props.COUPON_CODE_DETAIL.data;

      return _react2.default.createElement(
        'div',
        { style: { display: 'block', width: '100%', height: '100%' } },
        data ? this.renderContent() : _react2.default.createElement(
          'div',
          { className: styles.notfound },
          'Trang kh\xF4ng t\xECm th\u1EA5y'
        )
      );
    }
  }]);
  return BookingReward;
}(_react.Component), _class2.propTypes = {
  // @data
  params: _react.PropTypes.object,
  COUPON_CODE_DETAIL: _react.PropTypes.object,
  user: _react.PropTypes.object,
  history: _react.PropTypes.object,
  // @action
  getCodeDetail: _react.PropTypes.func,
  setDefaultBooking: _react.PropTypes.func,
  setPathName: _react.PropTypes.func.isRequired,
  resetBooking: _react.PropTypes.func,
  changeShopBeforeBooking: _react.PropTypes.func,
  showDownloadAppPopup: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = BookingReward;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Voucher/BookingReward.js
// module id = 1636
// module chunks = 0